import { createClient } from 'contentful';

/**
 * Initializes and exports the Contentful client using the provided 
 * Space ID and Access Token.
 * * NOTE: In a professional production environment, these credentials should 
 * be loaded securely from environment variables (e.g., process.env.REACT_APP_SPACE_ID).
 */
const client = createClient({
  space: '4lne3gk55jdy',
  accessToken: 'cRmvz_Di8JBejD7it5gvdhgzrzwEC6eI8AkR_vdcwR0',
});

export default client;